// extracted by mini-css-extract-plugin
export default {"filters":"UsersFilters_filters__croyQ","filters__total-items":"UsersFilters_filters__total-items__Tdlz-","filters__loader":"UsersFilters_filters__loader__Ia+w3"};